import { Injectable, Pipe, PipeTransform, inject } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { SEU_SVG_CHIMNEY, SEU_SVG_NOT_FOUND } from '@seu-helpers';
import { StoreService } from '@seu-services';
import { SEU_CHIMNEY_COMPONENT_TYPE } from '@seu-types';

@Injectable({ providedIn: 'root' })
@Pipe({
  name: 'seuConfigSvg',
})
export class SeuConfigSvgPipe implements PipeTransform {
  private readonly store = inject(StoreService);
  private readonly sanitizer = inject(DomSanitizer);

  public transform(key: string): SafeHtml {
    const svgs = this.store.getConfig()?.svgs;
    const notFoundSvg = SEU_SVG_NOT_FOUND;

    const chimneySvg = SEU_SVG_CHIMNEY;

    if (key === SEU_CHIMNEY_COMPONENT_TYPE) {
      return this.sanitizer.bypassSecurityTrustHtml(chimneySvg);
    }

    if (!svgs) {
      return this.sanitizer.bypassSecurityTrustHtml(notFoundSvg);
    }

    let svg = svgs[key];
    if (!svg) {
      svg = svgs[key.toLowerCase()];
    }

    return this.sanitizer.bypassSecurityTrustHtml(svg ?? notFoundSvg);
  }
}
